(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-article-associates"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.similaires__cards')) {
        new Swiper('.similaires__cards', {
            // Mobile first
            slidesPerView: 1.6,
            // slidesPerGroup: 1,
            navigation: {
                nextEl: '.similaires__swiper-next',
                prevEl: '.similaires__swiper-prev',
            },
            breakpoints: {
                // Les paramètres pour les écrans de plus de 768px
                768: {
                    slidesPerView: 6,
                    // slidesPerGroup: 6,
                    spaceBetween: 15,
                },
            },
        });
    }

    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-explore-all-categories"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.explore-all-categories__cards', {
        // Mobile first
        slidesPerView: 'auto',
        spaceBetween: 10,
        // slidesPerGroup: 1,
        navigation: {
            nextEl: '.explore-all-categories__swiper-next',
            prevEl: '.explore-all-categories__swiper-prev',
        },
        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: 'auto',
                // slidesPerView: 4.4,
                // slidesPerGroup: 6,
                spaceBetween: 20,
            },
        },
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-explore-categorie"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.explore-categorie__cards', {
        // Mobile first
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        navigation: {
            nextEl: '.explore-categorie__swiper-next',
            prevEl: '.explore-categorie__swiper-prev',
        },
        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: 3,
                slidesPerGroup: 6,
                grid: {
                    rows: 2,
                },
                spaceBetween: 15,
            },
        },
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-explore-conseils"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.explore-conseils__cards', {
        // Mobile first
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        navigation: {
            nextEl: '.explore-conseils__swiper-next',
            prevEl: '.explore-conseils__swiper-prev',
        },
        pagination: {
            el: '.swiper-pagination-conseils',
            type: 'progressbar',
            clickable: true,
        },
        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: 4,
                // slidesPerGroup: 6,
                spaceBetween: 20,
            },
        },
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-explore-inspirations"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.explore-inspirations__cards', {
        // Mobile first
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        navigation: {
            nextEl: '.explore-inspirations__swiper-next',
            prevEl: '.explore-inspirations__swiper-prev',
        },
        pagination: {
            el: '.swiper-pagination-inspirations',
            type: 'progressbar',
            clickable: true,
        },
        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: 3,
                slidesPerGroup: 6,
                grid: {
                    rows: 2,
                },
                spaceBetween: 20,
            },
        },
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-hero-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.hero-home__cards', {
        // Mobile first
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        spaceBetween: 10,

        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 10,
            },
        },
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-promotion-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.promotion-home__cards', {
        // Mobile first
        slidesPerView: 1.6,
        slidesPerGroup: 1,
        spaceBetween: 10,

        navigation: {
            nextEl: '.promotion-home__swiper-next',
            prevEl: '.promotion-home__swiper-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar',
            clickable: true,
        },
        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 10,
            },
        },
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-recommended-associates"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.complementaires__cards', {
        // Mobile first
        slidesPerView: 1.6,
        // slidesPerGroup: 1,
        navigation: {
            nextEl: '.complementaires__swiper-next',
            prevEl: '.complementaires__swiper-prev',
        },
        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: 3,
                // slidesPerGroup: 6,
                spaceBetween: 15,
            },
        },
    });
    new Swiper('.similaires__cards', {
        // Mobile first
        slidesPerView: 1.6,
        // slidesPerGroup: 1,
        navigation: {
            nextEl: '.similaires__swiper-next',
            prevEl: '.similaires__swiper-prev',
        },
        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: 3,
                // slidesPerGroup: 6,
                spaceBetween: 15,
            },
        },
    });


    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // Ribbon
  document.addEventListener("DOMContentLoaded", function () {
    Marquee3k.init();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.carrousel_images')) {
    new Swiper('.carrousel_images', {
        // Mobile first
        slidesPerView: 1.6,
        // slidesPerGroup: 1,
        navigation: {
            nextEl: '.carrousel_images__swiper-next',
            prevEl: '.carrousel_images__swiper-prev',
        },
        breakpoints: {
            // Les paramètres pour les écrans de plus de 768px
            768: {
                slidesPerView: "auto",
                // slidesPerGroup: 3,
                spaceBetween: 5,
            },
        },
    });
  }
  document.querySelectorAll(".wysiwyg p").forEach(p => {
    const paddingLeft = p.style.paddingLeft; // Récupère le padding-left défini en inline

    if (p.querySelector("iframe")) {
        p.classList.add("has-iframe");
    } else if (p.querySelector("img")) {
      p.classList.add("has-image");
    } else if (paddingLeft === "40px") {
        p.classList.add("padded-text");
    } else {
        p.classList.add("text-only");
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
    const menuLinks = document.querySelectorAll(".menu-faq__group");
    const faqGroups = document.querySelectorAll(".faq-group");
    const menuFaq = document.querySelector(".menu-faq__groups");
    const menuContainer = document.querySelector(".menu-faq__questions");
    const backButtons = document.querySelectorAll(".faq-back-button");

    function isMobile() {
        return window.innerWidth < 768; // Breakpoint mobile
    }

    function activateGroup(targetId) {
        const targetGroup = document.getElementById(targetId);
        if (!targetGroup) return;

        if (isMobile()) {
            // Sur mobile, cache le menu et affiche le bon groupe
            menuFaq.style.display = "none";
            targetGroup.style.display = "block";
        } else {
            // Desktop: Masquer tous les groupes
            faqGroups.forEach(group => group.style.display = "none");
            targetGroup.style.display = "block";

            // Met à jour l'état actif du menu
            menuLinks.forEach(link => {
                link.classList.remove("active");
                if (link.getAttribute("href") === "#" + targetId) {
                    link.classList.add("active");
                }
            });
        }
    }

    if (menuLinks.length > 0 && faqGroups.length > 0) {
        // Check for hash on load
        if (window.location.hash) {
            const hash = window.location.hash.substring(1);
            activateGroup(hash);
        } else {
             // Desktop: Masquer tous les groupes sauf le premier si pas de hash
            if (!isMobile()) {
                faqGroups.forEach((group, index) => {
                    if (index !== 0) {
                        group.style.display = "none";
                    }
                });
            }
        }

        menuLinks.forEach((link, index) => {
            link.addEventListener("click", function (event) {
                // Laissez le comportement par défaut pour mettre à jour l'URL
                // event.preventDefault(); 

                const targetId = this.getAttribute("href").substring(1);
                activateGroup(targetId);
            });
        });

        // Gérer le bouton "Retour" sur mobile
        backButtons.forEach(button => {
            button.addEventListener("click", function () {
                menuFaq.style.display = "flex"; // Réaffiche le menu
                faqGroups.forEach(group => group.style.display = "none"); // Cache tous les groupes
                // Optionnel : retirer le hash de l'URL quand on revient en arrière
                history.pushState("", document.title, window.location.pathname + window.location.search);
            });
        });
    }
});

  } catch(e) { console.error(e); }
})();
})();
